import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

const orderStore = new Vuex.Store({
  state: {
    orderArray: [],
    orderArray2d: [],
    currentOrder: {}, //orderDetail の際に使うか？使わないか？
  },
  mutations: {
    updateOrderArray(state, orderArray) {
      state.orderArray = orderArray;
    },
    updateOrderArray2d(state, orderArray2d) {
      state.orderArray2d = orderArray2d;
    },
    updateCurrentOrder(state, currentOrder) {
      state.currentOrder = currentOrder;
    },
    resetCurrentOrder(state) {
      state.currentOrder = {};
    },
    updateTracking(state, payload) {
      state.orderArray2d.forEach((orderArr) => {
        orderArr.forEach((order) => {
          if (order.order_key === payload.orderKey) {
            if (
              order.estimation.destinations &&
              Array.isArray(order.estimation.destinations)
            ) {
              order.estimation.destinations.forEach((dest) => {
                if (dest.id === payload.destinationId) {
                  dest.shipping_company = payload.shippingCompany;
                  dest.tracking = payload.tracking;
                }
              });
            }
          }
        });
      });
    },
  },
  getters: {
    orderArray: (state) => state.orderArray,
    orderArray2d: (state) => state.orderArray2d,
    currentOrder: (state) => state.currentOrder,
    currentDataType: (getters) => getters.currentOrder.estimation?.data_type,
  },
  plugins: [createPersistedState()],
});

export { orderStore };
